import { render, staticRenderFns } from "./creation-add.vue?vue&type=template&id=c7664b28&scoped=true"
import script from "./creation-add.vue?vue&type=script&lang=js"
export * from "./creation-add.vue?vue&type=script&lang=js"
import style0 from "./creation-add.vue?vue&type=style&index=0&id=c7664b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7664b28",
  null
  
)

export default component.exports